module.exports = __webpack_public_path__ + "static/media/banner2-julho2024-mobile.ecebbb06.jpg";